import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, retry, timeout } from 'rxjs/internal/operators';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { HelperService } from './helper.service';

const endpoint = 'https://xh0s282eok.execute-api.us-east-2.amazonaws.com';
const QUOTE_URL = `${endpoint}/latest/inquiry`;

var options = {
	headers: {
		'Content-Type':  'application/json'
	}
};

@Injectable({
  providedIn: 'root'
})

export class ApiService {
  constructor(private http: HttpClient,
              private helper: HelperService) { }

	requestQuote(data: any): Observable<any> {
		console.log(data);
		options['body'] = data;
	  return this.http.post<any>(QUOTE_URL, options)
	  	.pipe(
	  		catchError(this.handleError<any[]>('requestQuote', [])),
	  		timeout(30000)
  		);
	}

  getQuote(executionId: string) {
    let params = new HttpParams();
    params = params.append('id', executionId);
    
    return this.helper.startPoll<any>(
      () => this.http.get<any>(QUOTE_URL, { params: params}),
      response => response.status != "RUNNING"
    )
  }
	
	private handleError<T>(operation = 'operation', result?: T) {
	  return (error: any): Observable<T> => {
	    console.error(error);
	    this.log(`${operation} failed: ${error.message}`);

	    return of(result as T);
	  };
	}

	private log(message: string) {
	  console.log(message);
	}
}
